import React from 'react';

interface FormatTimeProps {
    date: string | Date;
}

export const FormatTime: React.FC<FormatTimeProps> = ({ date }) => {
    const ts = typeof date === 'string' ? new Date(date) : date;
    return <span className="chat-msg-time">{ts.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>;
};
